import React, { useState } from 'react'
import MobileHeader from '../../components/header/MobileHeader'
import LoginHeader from '../../components/header/LoginHeader'
import Footer from '../../components/footer'
import Gotop from '../../components/gotop'
import Blockcompany from './Blockcompany'
import LoginMobileHeader from '../../components/header/LoginMobileHeader'

const BlockCompanies = () => {

  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      <LoginMobileHeader handleMobile={handleMobile} />
      <LoginHeader clname="appliedjob" handleMobile={handleMobile} />
      <Blockcompany />
      {/* <Footer /> */}
      <Gotop />
    </>
  )
}

export default BlockCompanies